import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import FaceTwoToneIcon from '@mui/icons-material/FaceTwoTone';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BusinessIcon from '@mui/icons-material/Business';

const ICON_BY_KEY = {
  dashboard: <DashboardIcon />,
  partner_management_menu: <PersonIcon />,
  user_management_menu: <AssignmentIndIcon />,
  transaction_menu: <WorkOutlineIcon />,
  customer_menu: <FaceTwoToneIcon />,
  report_menu: <ArticleIcon />,
  master_setup_menu: <SettingsIcon />,
  business_profile_menu: <BusinessIcon />,
};

export function getSidebarIconForMenu(menuNode) {
  const key = menuNode?.name?.toLowerCase();

  return ICON_BY_KEY[key];
}
